import { useEffect, useRef } from 'react';
import { useDrag } from 'react-dnd';

import TemplateItemRow from './TemplateItemRow';
import AppVal from 'constants/frontend/app/AppVal';

function DraggableRow({ index }: { index: number }) {
  const rowRef = useRef<HTMLDivElement | null>(null);
  const handleRef = useRef<HTMLButtonElement | null>(null);

  const [{ isDragging }, drag, preview] = useDrag<
    { index: number; height: number },
    void,
    { isDragging: boolean }
  >({
    type: AppVal.DRAG_ITEM_EXISTING_HOMEWORK,
    item: () => {
      const height = rowRef.current?.offsetHeight ?? 0;
      return { index, height };
    },
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
  });

  // Row is just a preview root; handle is the drag source
  useEffect(() => {
    if (rowRef.current) preview(rowRef);
    if (handleRef.current) drag(handleRef);
  }, [preview, drag]);

  return (
    <TemplateItemRow index={index} isDragging={isDragging} rowRef={rowRef} handleRef={handleRef} />
  );
}

export default DraggableRow;
